import i18n from '../i18nService';
import { formNamesService } from './formNamesService';

const formsService = {
    getLocalization(localeCode, formOrCode, withCodeReplace, i18nInstance = i18n) {
        return formNamesService.getLocalization(localeCode, formOrCode, withCodeReplace, i18nInstance);
    },
    getPlaceholder(i18nInstance = i18n) {
        return formNamesService.getPlaceholder(i18nInstance);
    },
};

export { formsService };
